
export default function AboutSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Insured & Bonded',
      description: 'Fully licensed, insured, and bonded for your peace of mind.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Eco-Friendly',
      description: 'Safe, non-toxic cleaning products that protect your family and environment.'
    },
    {
      icon: 'ri-time-line',
      title: 'Flexible Scheduling',
      description: 'We work around your schedule with convenient booking options.'
    },
    {
      icon: 'ri-star-line',
      title: 'Quality Guarantee',
      description: '100% satisfaction guarantee - we\'ll make it right if you\'re not happy.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Why Choose KAILE BRIGHT?
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              With over 5 years of experience serving Metro City, we've built our reputation on 
              reliability, attention to detail, and exceptional customer service. Our trained 
              professionals use the latest equipment and eco-friendly products to deliver 
              outstanding results every time.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg mr-4 flex-shrink-0">
                    <i className={`${feature.icon} text-blue-600`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">{feature.title}</h3>
                    <p className="text-sm text-gray-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/3f279d63230bd2e17c928020299d6ca0.jpg"
              alt="Professional cleaning team"
              className="rounded-2xl shadow-xl object-cover w-full h-96"
            />
            <div className="absolute -bottom-6 -left-6 bg-blue-600 text-white p-6 rounded-xl shadow-lg">
              <div className="text-2xl font-bold">500+</div>
              <div className="text-sm">Satisfied Customers</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
